import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { pluralise } from "repoV2/features/Common/utils/strings";
import styles from "./QuantitySelector.module.scss";

const QuantitySelector = (props: {
    currentQuantity: number;
    quantityName: string;
    onIncrease: () => void;
    onDecrease: () => void;
}) => {
    const {
        currentQuantity,
        quantityName = "Item",
        onIncrease,
        onDecrease,
    } = props;

    return (
        <div className={styles.containerStyle}>
            <div className={styles.iconContainerStyle}>
                <RemoveCircleIcon
                    className={styles.iconStyles}
                    classes={{
                        colorSecondary: styles.secondaryStyle,
                    }}
                    onClick={onDecrease}
                />
            </div>
            <div className={styles.itemStyle}>{`${currentQuantity} ${pluralise(
                quantityName,
                currentQuantity
            )}`}</div>
            <div className={styles.iconContainerStyle}>
                <AddCircleIcon
                    className={styles.iconStyles}
                    classes={{
                        colorSecondary: styles.secondaryStyle,
                    }}
                    onClick={onIncrease}
                />
            </div>
        </div>
    );
};

export default QuantitySelector;
